<template>
  <div>
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 简历 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">简历</h2>
          </div>
          <div class="resumeSection__form">
            <el-form>
              <el-form-item>
                <el-upload
                  class="uploadFile"
                  ref="resumeUploader"
                  drag
                  name="content"
                  accept=".pdf"
                  :show-file-list="false"
                  action="#"
                  :auto-upload="false"
                  :on-change="handleResumeUploadChange"
                >
                  <div class="uploadFile__resume">
                    <div class="beforeUpload" v-if="!resume">
                      <h3>将你的简历拖拽到此处</h3>
                      <div class="upload-button">
                        <bytedance-button round type="primary"
                          >选择文件</bytedance-button
                        >
                      </div>
                      <div>请上传 .pdf 文件</div>
                    </div>
                    <div class="afterUpload" v-else>
                      <div class="fileicon">
                        <file-icon :fileType="resumeFileType"></file-icon>
                      </div>
                      <h3>{{ resume }}</h3>
                      <div class="afterUpload__actionButton">
                        <span class="afterUpload__actionButton-update"
                          >更新</span
                        >
                        <span class="afterUpload__actionButton-dividerLine"
                          >|</span
                        >
                        <span @click.stop="handleRemoveUploadResume">删除</span>
                      </div>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { personalInfo, resumeUpload } from "@/api/index";
import { mapGetters } from "vuex";
import COS from "cos-js-sdk-v5";
export default {
  name: "resume-editor",
  data() {
    return {
      URL: "/prod-api",
      userInfo: {},
      resume: "",
    };
  },
  computed: {
    ...mapGetters([
      "phoneNumber",
    ]),
    resumeFileType() {
      const patharr = this.resume.split(".");
      return patharr[patharr.length - 1].toLowerCase();
    },
  },

  created() {
    this.getPersonalInfo();
  },

  methods: {
    getPersonalInfo() {
      personalInfo()
        .then((res) => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson !== null) {
              this.userInfo = res.data.reMiniProgramPerson;
            }
            this.resume = res.data.resume;
          }
        })
        .catch((err) => {});
    },

    //删除简历
    handleRemoveUploadResume() {
      this.resume = "";
      this.$refs.resumeUploader.value = "";
    },

    handleResumeUploadChange(file) {
      if (file.status === "ready" && this.userInfo) {
        let types = file.name.split(".")[1];
        if (types == "pdf") {
          let objectKey =
            "湖北省残疾人求职招聘信息平台/用户信息/附件简历/" +
            this.userInfo.realName +
            "/" +
            this.phoneNumber +
            "." +
            types;
          if (file.raw) {
            const files = file.raw;
            let filesSize = files.size;
            if (filesSize / (1024 * 1024) < 30) {
              this.uploads(files, objectKey);
            } else {
              this.$message({
                type: "warning",
                message: "文件过大，建议不要超过30M！",
              });
            }
          }
        } else {
          this.$message({
            type: "warning",
            message: "请上传PDF文件",
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请前往我的简历去填写个人信息",
        });
      }
    },

    //loading
    showLoading() {
      this.load = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    //上传
    uploads(files, objectKey) {
      let _this = this;
      _this.showLoading();
      // 初始化实例
      const cos = new COS({
        // getAuthorization 必选参数
        getAuthorization: function (options, callback) {
          const url = _this.URL + "/api/miniProgram/getCosAuth";
          const xhr = new XMLHttpRequest();
          xhr.open("get", url, true);
          xhr.onload = function (e) {
            let data = JSON.parse(xhr.response).data;
            console;
            let timestamp = Math.floor(data.startTime / 1000);
            callback({
              TmpSecretId: data.tmpSecretId,
              TmpSecretKey: data.tmpSecretKey,
              SecurityToken: data.sessionToken,
              StartTime: timestamp, // 时间戳，单位秒，如：1580000000
              ExpiredTime: timestamp + 60, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        },
      });

      cos.uploadFile(
        {
          Bucket: "zhaopin-1322091753" /* 填写自己的 bucket，必须字段 */,
          Region: "ap-nanjing" /* 存储桶所在地域，必须字段 */,
          Key: objectKey /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
          Body: files, // 上传文件对象
          SliceSize:
            1024 *
            1024 *
            30 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          onProgress: function (progressData) {
            console.log(JSON.stringify(progressData));
          },
        },
        function (err, data) {
          if (err) {
            _this.load.close();
            _this.$message.error("上传失败");
          } else {
            resumeUpload(objectKey)
              .then((res) => {
                if (res.code == 200) {
                  _this.resume = objectKey;
                  _this.load.close();
                  _this.$message({
                    type: "success",
                    message: "上传成功!",
                  });
                } else {
                  _this.load.close();
                  this.$message({
                    type: "warning",
                    message: res.msg,
                  });
                }
              })
              .catch(() => {});
          }
        }
      );
    },
  },
};
</script>

<style lang="less">
.el-upload {
  width: 100%;
  .uploadFile__works {
    .uploadWorks__fileicon {
      width: 50px;
      height: 50px;
      margin: auto;
    }
    .el-icon-warning {
      font-size: 30px;
    }
  }
  &:focus {
    border-color: inherit;
    color: inherit;
  }
  &-dragger {
    display: table-cell;
    vertical-align: middle;

    border: none;
    background: @bg-base-color;
    width: 600px;
    .upload-button {
      display: inline-block;
      width: 100px;
      margin: 10px 0;
    }

    .afterUpload {
      .fileicon {
        width: 50px;
        height: 50px;
        margin: auto;
      }
      time {
        color: @secondary-text-color;
      }
      &__actionButton {
        color: @main-color;
        &-dividerLine {
          margin: 0 14px;
        }
      }
    }
  }
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 130px 0;
}
.resumeEditor-footerAction {
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;

  &__title {
    margin-right: 200px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
  }
}
</style>
